export default __webpack_public_path__ + "a6ae27a163b73dc3fe33a080c686c4e9.svg";